import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/ui/layout.js";
import { Link } from 'gatsby';
import FileSystemExample from '~/examples/file-system';
import { SourceCode } from '~/ui';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`An interpretation of a simple file system built on the web using `}<inlineCode parentName="p">{`unified-doc`}</inlineCode>{`.  This example uses the `}<inlineCode parentName="p">{`DocPreview`}</inlineCode>{` component that is detailed in the `}<Link to="/examples/doc-preview" mdxType="Link">{`Doc preview example`}</Link>{`.`}</p>
    <p>{`This example is used in the home page!`}</p>
    <SourceCode source="examples/file-system" mdxType="SourceCode" />
    <h3 {...{
      "id": "features"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Features from the `}<Link to="/examples/doc-preview" mdxType="Link">{`Doc preview`}</Link>{` example apply here.`}</li>
      <li parentName="ul">{`Upload and preview any file using the `}<inlineCode parentName="li">{`DocPreview`}</inlineCode>{` component.`}</li>
      <li parentName="ul">{`Search/filter for files.`}</li>
      <li parentName="ul">{`Hide/show file extensions.`}</li>
    </ul>
    <h3 {...{
      "id": "concepts"
    }}>{`Concepts`}</h3>
    <ul>
      <li parentName="ul">{`Most concepts from the `}<Link to="/examples/doc-preview" mdxType="Link">{`Doc preview`}</Link>{` example apply here.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`dom.fromFile()`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "demo"
    }}>{`Demo`}</h3>
    <FileSystemExample mdxType="FileSystemExample" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      